<template>
    <div class="form-field form-autocomplete" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">

                <!--
                <component-multiselect v-model="internalValue"
                                       tag-placeholder="Add this as new tag"
                                       placeholder="Search or add a tag"
                                       label="name"
                                       track-by="code"
                                       :options="options"
                                       :multiple="true"
                                       :taggable="true"
                                       @tag="addTag"
                                       @search-change="asyncFind">
                 </component-multiselect>
                 -->

                <component-multiselect v-model="internalValue"
                                       :show-labels="false"
                                       label="name"
                                       track-by="id"
                                       placeholder="Rechercher..."
                                       :options="data"
                                       :multiple="isMultiple"
                                       :searchable="true"
                                       :loading="isLoading"
                                       :internal-search="false"
                                       :clear-on-select="true"
                                       :options-limit="300"
                                       :limit-text="limitText"
                                       :max-height="300"
                                       :show-no-results="false"
                                       :hide-selected="true"
                                       tag-placeholder=""
                                       :taggable="true"
                                       @tag="addTag"
                                       @search-change="asyncFind">
                    <template slot="clear" slot-scope="props">
                        <div class="multiselect__clear" v-if="internalValue" @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template><span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                </component-multiselect>

                <button class="bt-remove" @click="clearAll()"><i class="icon icon-icon_close"></i></button>
            </div>
        </div>
    </div>
</template>

<script>

    import TagService from './../../modules/config/tag/TagService.js';

    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','multiple','id','service','update','required'],
        data: function () {
            return {
                internalValue: '',
                data: [],
                isLoading: false,
                tagService: null
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.isMultiple = true;
            this.requiredForm = this.required && this.required == 'true' ? true : false

            this.tagService = TagService;
        },
        methods: {
            limitText (count) {
                return `and ${count} other tags`
            },
            asyncFind (query) {
                if( query ){
                    this.tagService.all('?query=' + query ).then(response => {
                        if( response ){
                            this.data = response.data.data ? response.data.data : response.data
                        }
                    })
                }
            },
            addTag (string){
                this.tagService.add({name:string,translations:{fr:{name:string}}}).then(response => {
                    if( response ){
                        this.value.push({id:response.data.id, name:response.data.name})
                        this.$forceUpdate();
                    }
                })
            },
            clearAll () {
                this.internalValue = []
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Tag.vue